import { REPORT_TYPES } from '../../frontend/components/reports/ReportTypeTabs';

export const BASE_REPORTS_URL = 'reports/';

export const BASE_ACTIVITY_REPORT_URL = `/${BASE_REPORTS_URL}${REPORT_TYPES.ACTIVITY_REPORT}/`;
export const BASE_COACH_REPORT_URL = `/${BASE_REPORTS_URL}${REPORT_TYPES.COACH_REPORT}/`;
export const BASE_TEAM_PROGRESS_REPORTS_URL = `/${BASE_REPORTS_URL}${REPORT_TYPES.TEAM_PROGRESS_REPORT}/`;
export const BASE_MOMENT_REPORTS_URL = `/${BASE_REPORTS_URL}${REPORT_TYPES.MOMENTS_REPORT}/`;
export const BASE_ASSIGNMENT_PATH_REPORTS_URL = `/${BASE_REPORTS_URL}${REPORT_TYPES.ASSIGNMENT_PATH_REPORT}/`;
export const BASE_AI_TRAINING_REPORT_URL = `/${BASE_REPORTS_URL}${REPORT_TYPES.AI_TRAINING_REPORT}/`;
export const BASE_OUTSTANDING_REPORT_URL = `/${BASE_REPORTS_URL}${REPORT_TYPES.OUTSTANDING_REPORT}`;
export const BASE_SIMULATION_SKILLS_REPORT_URL = `/${BASE_REPORTS_URL}${REPORT_TYPES.SIMULATION_SKILLS_REPORT}`;

export const ALL_TIER_ONE_TEAMS_PROGRESS_REPORT_URL = `${BASE_TEAM_PROGRESS_REPORTS_URL}teams`; // tier 1
export const INDIVIDUAL_COACH_REPORT_URL = `${BASE_COACH_REPORT_URL}:coachId`;
export const ALL_TIER_TWO_TEAMS_PROGRESS_REPORT_URL = `${ALL_TIER_ONE_TEAMS_PROGRESS_REPORT_URL}/:teamId`; // tier 2
export const ALL_TIER_THREE_TEAMS_PROGRESS_REPORT_URL = `${ALL_TIER_TWO_TEAMS_PROGRESS_REPORT_URL}/:teamId`; // tier 3
export const ALL_TIER_FOUR_TEAMS_PROGRESS_REPORT_URL = `${ALL_TIER_THREE_TEAMS_PROGRESS_REPORT_URL}/:teamId`; // tier 4
export const INDIVIDUAL_PATH_PROGRESS_REPORT_URL = `${ALL_TIER_FOUR_TEAMS_PROGRESS_REPORT_URL}/path/:pathId`;
export const INDIVIDUAL_TEAM_PROGRESS_REPORT_URL = `${ALL_TIER_FOUR_TEAMS_PROGRESS_REPORT_URL}/:teamId`; // users

export const TRAINEE_PROGRESS_REPORT_URL = `${INDIVIDUAL_TEAM_PROGRESS_REPORT_URL}/trainee/:traineeId`;

export const TRAINEE_PATH_PROGRESS_REPORT_URL = `${INDIVIDUAL_PATH_PROGRESS_REPORT_URL}/trainee/:traineeId`;

export const TEAM_OUTSTANDIG_REPORT_URL = `${BASE_OUTSTANDING_REPORT_URL}/:teamId`;

export const getIndividualCoachReportURL = (coachId) => INDIVIDUAL_COACH_REPORT_URL.replace(':coachId', coachId);

export const getIndividualTeamProgressReportURL = (
  teamId, tier, tierIds, assignmentPath,
) => {
  if (tier === 1) {
    let url = ALL_TIER_TWO_TEAMS_PROGRESS_REPORT_URL
      .replace(':teamId', teamId);
    url += `?assignmentPath=${assignmentPath}`;
    return url;
  }
  if (tier === 2) {
    let url = ALL_TIER_ONE_TEAMS_PROGRESS_REPORT_URL;
    tierIds.forEach((id) => url += `/${id}`);
    url += `/${teamId}`;
    url += `?assignmentPath=${assignmentPath}`;
    return url;
  }
  if (tier === 3) {
    let url = ALL_TIER_ONE_TEAMS_PROGRESS_REPORT_URL;
    tierIds.forEach((id) => url += `/${id}`);
    url += `/${teamId}`;
    url += `?assignmentPath=${assignmentPath}&listingGroup=team`;
    return url;
  }
  if (tier === 4) {
    let url = ALL_TIER_ONE_TEAMS_PROGRESS_REPORT_URL;
    tierIds.forEach((id) => url += `/${id}`);
    url += `/${teamId}`;
    url += `?assignmentPath=${assignmentPath}`;
    return url;
  }
  return null;
};

export const getIndividualPathProgressReportURL = (id, tierIds, assignmentPath, optionalParams) => {
  let url = ALL_TIER_ONE_TEAMS_PROGRESS_REPORT_URL;
  tierIds.forEach((id) => url += `/${id}`);
  url += `/path/${id}`;

  const params = new URLSearchParams();
  if (assignmentPath) params.append('assignmentPath', assignmentPath);
  if (optionalParams) {
    Object.keys(optionalParams).forEach((key) => {
      params.append(key, optionalParams[key]);
    });
  }
  if (params.toString()) {
    url += `?${params.toString()}`;
  }
  return url;
};

export const getTierURL = (tierIds, assignmentPath, listingGroup, optionalParams) => {
  let url = ALL_TIER_ONE_TEAMS_PROGRESS_REPORT_URL;
  tierIds.forEach((id) => url += `/${id}`);

  const params = new URLSearchParams();
  if (assignmentPath) params.append('assignmentPath', assignmentPath);
  if (listingGroup) params.append('listingGroup', listingGroup);
  if (optionalParams) {
    Object.keys(optionalParams).forEach((key) => {
      params.append(key, optionalParams[key]);
    });
  }
  if (params.toString()) {
    url += `?${params.toString()}`;
  }
  return url;
};

export const getTraineeProgressReportURL = (
  teamId,
  traineeID,
  tier,
  tierIds,
  pathId,
) => {
  let url = getTierURL(tierIds);
  if (pathId) {
    url += `/path/${pathId}`;
  }
  url += `/trainee/${traineeID}`;
  return url;
};
